var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: { title: "编辑指标项", visible: _vm.visible },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "指标项：", prop: "name" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入指标项" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }